import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import Cluster from "ol/source/Cluster";
import Feature from "ol/Feature";
import JobStyle from "../styles/jobs";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { fromLonLat } from "ol/proj.js";
export default class JobLayer {
    constructor(distance = 40) {
        this.style = new JobStyle();
        this.cluster = new Cluster({
            distance: distance,
            source: new VectorSource(),
        });
        this.animatedCluster = new AnimatedCluster({
            name: "Jobs",
            source: this.cluster,
            style: (cluster) => this.style.clusterStyle(cluster),
        });
        this.areas = new VectorLayer({
            source: new VectorSource(),
        });
    }
    setJobs(location) {
        const points = [];
        location.forEach(ort => {
            const newFeature = this.createSingleLocationFeat(ort);
            newFeature.set("job", ort, false);
            newFeature.set("weight", ort.weight, false);
            points.push(newFeature);
        });
        this.cluster.getSource().clear();
        this.cluster.getSource().addFeatures(points);
    }
    createSingleLocationFeat(location) {
        return new Feature({
            geometry: new Point(fromLonLat([parseFloat(location.lng), parseFloat(location.lat)])),
        });
    }
    getCluster() {
        return this.cluster;
    }
}
